export const GET_ACCESS_HOURS = 'GET_ACCESS_HOURS';
